import { observer } from 'mobx-react-lite';
import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { Container, Dropdown, Image, Menu } from 'semantic-ui-react';

import { RootStoreContext } from '../../app/stores/rootStore';

const NavBar: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const { clerk, signout } = rootStore.clerkStore;

  return (
    <Menu fixed='top' inverted>
      <Container>
        <Menu.Item header exact as={NavLink} to='/admin'>
          <Image
            size='tiny'
            src='/assets/logo.png'
            style={{ marginRight: '16px' }}
          />
          <label style={{ paddingTop: '13px' }}>東京タワー 預託</label>
        </Menu.Item>
        <Menu.Item as={NavLink} exact to='/admin/depositsales'>
          <label style={{ paddingTop: '10px' }}>預託チケット一覧</label>
        </Menu.Item>
        <Menu.Item as={NavLink} exact to='/admin/depositsales/create'>
          <label style={{ paddingTop: '10px' }}>新規預託チケット作成</label>
        </Menu.Item>
        <Menu.Item as={NavLink} exact to='/admin/depositsales/upload'>
          <label style={{ paddingTop: '10px' }}>CSVアップロード</label>
        </Menu.Item>
        <Menu.Item as={NavLink} exact to='/admin/reservations/createFrame'>
          <label style={{ paddingTop: '10px' }}>預託TDT枠管理</label>
        </Menu.Item>
        <Menu.Item as={NavLink} exact to='/admin/depositsales/print'>
          <label style={{ paddingTop: '10px' }}>預託チケット発券管理</label>
        </Menu.Item>

        {clerk && (
          <Menu.Item position='right'>
            <Dropdown
              style={{ paddingTop: '10px' }}
              pointing='top left'
              text={clerk.clerkName}
            >
              <Dropdown.Menu>
                <Dropdown.Item onClick={signout} text='Logout' icon='power' />
              </Dropdown.Menu>
            </Dropdown>
          </Menu.Item>
        )}
      </Container>
    </Menu>
  );
};

export default observer(NavBar);
